export const optionsProvinces = [
    {
        label: 'An Giang',
        value: 'AGI',
    },
    {
        label: 'Bà Rịa - Vũng Tàu',
        value: 'VTB',
    },
    {
        label: 'Bạc Liêu',
        value: 'BLI',
    },
    {
        label: 'Bắc Kạn',
        value: 'BKA',
    },
    {
        label: 'Bắc Giang',
        value: 'BGI',
    },
    {
        label: 'Bắc Ninh',
        value: 'BNI',
    },
    {
        label: 'Bến Tre',
        value: 'BTR',
    },
    {
        label: 'Bình Dương',
        value: 'BDU',
    },
    {
        label: 'Bình Định',
        value: 'BDI',
    },
    {
        label: 'Bình Phước',
        value: 'BPC',
    },
    {
        label: 'Bình Thuận',
        value: 'BTN',
    },
    {
        label: 'Cà Mau',
        value: 'CMU',
    },
    {
        label: 'Cao Bằng',
        value: 'CBA',
    },
    {
        label: 'Cần Thơ',
        value: 'CTH',
    },
    {
        label: 'Đà Nẵng',
        value: 'DNG',
    },
    {
        label: 'Đắk Lắk',
        value: 'DLA',
    },
    {
        label: 'Đắk Nông',
        value: 'DKN',
    },
    {
        label: 'Điện Biên',
        value: 'DBI',
    },
    {
        label: 'Đồng Nai',
        value: 'DNA',
    },
    {
        label: 'Đồng Tháp',
        value: 'DTP',
    },
    {
        label: 'Gia Lai',
        value: 'GLA',
    },
    {
        label: 'Hà Giang',
        value: 'HGI',
    },
    {
        label: 'Hà Nam',
        value: 'HNA',
    },
    {
        label: 'Hà Nội',
        value: 'HNO',
    },
    {
        label: 'Hà Tĩnh',
        value: 'HTI',
    },
    {
        label: 'Hải Dương',
        value: 'HDU',
    },
    {
        label: 'Hải Phòng',
        value: 'HPG',
    },
    {
        label: 'Hậu Giang',
        value: 'HAG',
    },
    {
        label: 'Hòa Bình',
        value: 'HBI',
    },
    {
        label: 'Thành phố Hồ Chí Minh',
        value: 'HCM',
    },
    {
        label: 'Hưng Yên',
        value: 'HYE',
    },
    {
        label: 'Khánh Hòa',
        value: 'KHA',
    },
    {
        label: 'Kiên Giang',
        value: 'KGI',
    },
    {
        label: 'Kon Tum',
        value: 'KTU',
    },
    {
        label: 'Lai Châu',
        value: 'LCA',
    },
    {
        label: 'Lạng Sơn',
        value: 'LSN',
    },
    {
        label: 'Lào Cai',
        value: 'LCI',
    },
    {
        label: 'Lâm Đồng',
        value: 'LDG',
    },
    {
        label: 'Long An',
        value: 'LAN',
    },
    {
        label: 'Nam Định',
        value: 'NDH',
    },
    {
        label: 'Nghệ An',
        value: 'NAN',
    },
    {
        label: 'Ninh Bình',
        value: 'NBI',
    },
    {
        label: 'Ninh Thuận',
        value: 'NTH',
    },
    {
        label: 'Phú Thọ',
        value: 'PTH',
    },
    {
        label: 'Phú Yên',
        value: 'PYE',
    },
    {
        label: 'Quảng Bình',
        value: 'QBI',
    },
    {
        label: 'Quảng Nam',
        value: 'QNA',
    },
    {
        label: 'Quảng Ngãi',
        value: 'QNG',
    },
    {
        label: 'Quảng Ninh',
        value: 'QNH',
    },
    {
        label: 'Quảng Trị',
        value: 'QTR',
    },
    {
        label: 'Sóc Trăng',
        value: 'STG',
    },
    {
        label: 'Sơn La',
        value: 'SLA',
    },
    {
        label: 'Tây Ninh',
        value: 'TNI',
    },
    {
        label: 'Thái Bình',
        value: 'TBH',
    },
    {
        label: 'Thái Nguyên',
        value: 'TNG',
    },
    {
        label: 'Thanh Hóa',
        value: 'THA',
    },
    {
        label: 'Thừa Thiên Huế',
        value: 'TTH',
    },
    {
        label: 'Tiền Giang',
        value: 'TGG',
    },
    {
        label: 'Trà Vinh',
        value: 'TVH',
    },
    {
        label: 'Tuyên Quang',
        value: 'TQU',
    },
    {
        label: 'Vĩnh Long',
        value: 'VLG',
    },
    {
        label: 'Vĩnh Phúc',
        value: 'VPH',
    },
    {
        label: 'Yên Bái',
        value: 'YBA',
    },
];
